import { ReactNode } from 'react'

interface Props {
  label: ReactNode
  required?: boolean
  children: ReactNode
}

export const HorizontalRow = ({ label, required, children }: Props) => (
  <div className="booster-program-create__row">
    <div className="booster-program-create__row-label">
      {label}
      {required && <span className="booster-program-create__row-required"> *</span>}
    </div>
    <div className="booster-program-create__row-field">{children}</div>
  </div>
)
